import { render, staticRenderFns } from "./DeepTopelius.vue?vue&type=template&id=3dd9931c&"
import script from "./DeepTopelius.vue?vue&type=script&lang=js&"
export * from "./DeepTopelius.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports